import {
  ActiveDoctorListActionTypes,
  DOCTOR_LIST_FAIL,
  DOCTOR_LIST_LOADING,
  DOCTOR_LIST_SUCCESS,
  ActiveDoctorListState,
  DOCTOR_LIST_API_MSG,
  DOCTOR_LIST_API_RES,
} from "./ActionTypes";
import { DoctorListResponse } from "./Model";

const initialStateEditPosts: ActiveDoctorListState = {
  loading: false,
  doctorDetailsResponse: {} as DoctorListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const doctorListReducer = (
  state = initialStateEditPosts,
  action: ActiveDoctorListActionTypes
): ActiveDoctorListState => {
  switch (action.type) {
    case DOCTOR_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DOCTOR_LIST_SUCCESS:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        successMsg: action.successMsg,
      };
    case DOCTOR_LIST_FAIL:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_LIST_API_MSG:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_LIST_API_RES:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
